(function() {
  'use strict';
  angular.module('benefits')
    .component('accumulator', {
      bindings: {
        accumulators: '<',
        category: '=',
        accumsIndex: '<'
      },
      controller: [function accumulatorController() {
        var self = this;
        self.accums = [];
        self.$onInit = function() {
          self.category.accums = [];
          _.each(self.category.accumulators.id, function(accumulator) {
            var accum = _.find(self.accumulators, function(a){
              return accumulator==a.id;
            });
            self.category.accums.push(accum);
          });
        };
      }],
      templateUrl: 'js/benefits/accumulator.html' + appVersion
    });
})();
